import { HTML_REG } from "../data/RegRule";
export default function html2Escape(sHtml){
  if(!sHtml){ // 如果为空 直接返回
        return;
  }
  return sHtml.replace(HTML_REG, function(str){
    return { '<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;' }[str];
  })
}